'use client';

import our_people_icon_en from '@/../public/img/home/sustainability-logo/our_people_icon_en.png';
import our_people_icon_zh from '@/../public/img/home/sustainability-logo/our_people_icon_zh.png';
import our_planet_icon_en from '@/../public/img/home/sustainability-logo/our_planet_icon_en.png';
import our_planet_icon_zh from '@/../public/img/home/sustainability-logo/our_planet_icon_zh.png';
import our_products_icon_en from '@/../public/img/home/sustainability-logo/our_products_icon_en.png';
import our_products_icon_zh from '@/../public/img/home/sustainability-logo/our_products_icon_zh.png';
import {cn} from '@/lib/utils';
import {Locale, useTranslations} from 'next-intl';
import Image from 'next/image';
import Url from './Url';

const LatestSustainabilityStory = (Prop: {locale: Locale; moduleData: any}) => {
  const sustainabilityStoryItems = Prop.moduleData;
  const t = useTranslations('IndexPage');

  const images = {
    en: {
      people: our_people_icon_en.src,
      planet: our_planet_icon_en.src,
      products: our_products_icon_en.src
    },
    zh: {
      people: our_people_icon_zh.src,
      planet: our_planet_icon_zh.src,
      products: our_products_icon_zh.src
    }
  };

  const sustainabilityStoryTags: string[] = [
    'sustainability_planet',
    'sustainability_people',
    'sustainability_products'
  ];

  return (
    <div className="questrial text-[18px] flex flex-col gap-4 mb-4">
      {Object.values(sustainabilityStoryItems).length > 0 && (
        <div>
          <div className="flex justify-start items-center py-4">
            <h2 className="text-[#e21736] text-[26px] font-bold leading-[40px] tracking-normal mt-[10px] ">
              {t('latest-sustainability-story')}
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {sustainabilityStoryTags.map((tag) => {
              const sustainabilityStoryItem: {
                title: string;
                type: 'people' | 'planet' | 'products';
                slug: string;
                thumbnail: string;
              } = sustainabilityStoryItems[tag];
              if (sustainabilityStoryItem) {
                const image =
                  images[Prop.locale]?.[sustainabilityStoryItem.type];
                return (
                  <div className="relative" key={tag}>
                    <Url
                      href={
                        '/sustainability-story/' + sustainabilityStoryItem.slug
                      }
                      key={'newsItem_' + sustainabilityStoryItem.slug}
                    >
                      <div
                        className={cn(
                          'bg-[#f8f8f8] rounded-md cursor-pointer flex flex-col gap-2 border border-[#f8f8f8]',
                          'hover:bg-[#f0f0f0] hover:border-[#f0f0f0]'
                        )}
                      >
                        <div className="aspect-[16/9] w-full">
                          {sustainabilityStoryItem.thumbnail && (
                            <img
                              className="aspect-[16/9] w-full object-cover rounded-t-md"
                              src={sustainabilityStoryItem.thumbnail}
                              alt={`${sustainabilityStoryItem.title} thumbnail`}
                            />
                          )}
                        </div>
                        <div className="p-2">
                          <p className="font-bold md:text-base leading-tight overflow-hidden line-clamp-3 text-[#e21736] min-h-[75px]">
                            {sustainabilityStoryItem.title}
                          </p>
                          <div className="h-[70px]"></div>
                        </div>
                      </div>
                    </Url>
                    {image && (
                      <Url
                        href={
                          '/category/sustainability/' +
                          sustainabilityStoryItem.type
                        }
                        className="absolute bottom-5 right-5"
                      >
                        <Image
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          src={image.trim()}
                          alt={`${sustainabilityStoryItem.title} image`}
                          width={70}
                          height={70}
                          className="rounded-full hover:scale-110 transition-all duration-200"
                        />
                      </Url>
                    )}
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default LatestSustainabilityStory;
